/**
 * Tiny runtime polyfills for the Facebook / Instagram in-app browser.
 *
 * These webviews often ship with 2-3 year-old WebKit/Chromium builds and
 * are missing newer APIs we use throughout the app. Each polyfill below
 * is intentionally minimal — the goal is "don't blow up on load", not
 * spec-perfect behaviour.
 *
 * Order matters: install BEFORE any app code that might reference these.
 */

// String.prototype.replaceAll (Chrome < 85, Safari < 13.1)
if (typeof String.prototype.replaceAll !== "function") {
  // eslint-disable-next-line no-extend-native
  String.prototype.replaceAll = function replaceAll(search, replacement) {
    if (search instanceof RegExp) {
      const flags = search.flags.includes("g") ? search.flags : search.flags + "g";
      return this.replace(new RegExp(search.source, flags), replacement);
    }
    return this.split(String(search)).join(String(replacement));
  };
}

// Array.prototype.at (Chrome < 92, Safari < 15.4)
if (typeof Array.prototype.at !== "function") {
  // eslint-disable-next-line no-extend-native
  Array.prototype.at = function at(n) {
    const len = this.length;
    const i = Math.trunc(n) || 0;
    const k = i < 0 ? i + len : i;
    return k < 0 || k >= len ? undefined : this[k];
  };
}

// Promise.allSettled (Chrome < 76, Safari < 13)
if (typeof Promise.allSettled !== "function") {
  Promise.allSettled = function allSettled(promises) {
    return Promise.all(
      Array.from(promises, (p) =>
        Promise.resolve(p).then(
          (value) => ({ status: "fulfilled", value }),
          (reason) => ({ status: "rejected", reason })
        )
      )
    );
  };
}

// structuredClone (Chrome < 98, Safari < 15.4) — JSON fallback is sufficient
// for the plain-object payloads we clone (never Dates/Maps/Sets).
if (typeof window !== "undefined" && typeof window.structuredClone !== "function") {
  window.structuredClone = function structuredClone(value) {
    try {
      return JSON.parse(JSON.stringify(value));
    } catch {
      return value;
    }
  };
}

// globalThis (very old webviews)
if (typeof globalThis === "undefined") {
  // eslint-disable-next-line no-global-assign
  (function () {
    if (typeof self !== "undefined") self.globalThis = self;
    else if (typeof window !== "undefined") window.globalThis = window;
  })();
}
